import React, { useState, useEffect } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'
import DialogTitle from '@mui/material/DialogTitle'
import Grid from '@mui/material/Grid'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import Typography from '@mui/material/Typography'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { closePopup, showPopup } from '../../actions/uiActions'
import { changeQPs } from '../../actions/queryActions'
import downArrow from '../../images/js/downArrow'
import upArrow from '../../images/js/upArrow'
import { refreshPresentationSlide } from '../../actions/presentationActions'
import { getCurrentUser } from '../../actions/userActions'
import { withRouter } from '../../actions/withRouterHook'
import { doesThisUserHaveThisAuthorization, IsThisUserThePresentationsCreator, IsThisConnectionPowerBi } from '../../components/utilities/helperFunctions'
import ItemSelector from '../ui/ItemSelector'
import TrendEditor from '../ui/TrendEditor'
import 'react-super-treeview/dist/style.css'
import CloseIcon from '@mui/icons-material/Close'

function ChartQueryPopup(props) {
    let navigate = useNavigate();
    let [selectedChart, setSelectedChart] = useState(-1)
    let [selections, setSelections] = useState([])
    let [trends, setTrends] = useState([])
    let [slide, setSlide] = useState({})
    let [hideComps, setHideComps] = useState({
        "selections": true,
        "trends": true
    })
    let [formIsValid, setFormIsValid] = useState(true)
    let [userHasPermissionToView, setUserHasPermissionToView] = useState(false)
    let [userWasCreator, setUserWasCreator] = useState(false)
    let [validationErrorMessages, setValidationErrorMessages] = useState([])
    let [dataSeriesMsOpen, setDataSeriesMsOpen] = useState(false)
    let [dataCategoryMsOpen, setDataCategoryMsOpen] = useState(false)
    let [addedMultiSegments, setAddedMultiSegments] = useState([])
    let [quickPicksTags, setQuickPicksTags] = useState([])
    let [globals, setGlobals] = useState([])

    // trigger on component mount
    useEffect(() => {
        if (selectedChart === -1) {
            let slide = props.popupInfo.slide
            let copiedSlide = JSON.parse(JSON.stringify(slide))
    
            let selectedChartId;
            if (props.popupInfo.chartId) {
                selectedChartId = props.popupInfo.chartId
            } else {
                selectedChartId = (copiedSlide.xP3Charts.length > 0) ? copiedSlide.xP3Charts[0].id : -1
            }
    
            if (props.currentUser === null) {
                props.getCurrentUser(props.userID)
            } else {
                setIfUserHasAppropriatePermissions(props.currentUser)
                setIfUserIsCreator(props.currentUser, props.presentationView.presentation)
            }
    
            let selections = getFirstTimeLoadSelections(copiedSlide.xP3Charts)
            let trends = getFirstTimeTrends(copiedSlide.xP3Charts)
    
            let quickPicksTags = []
            props.popupInfo.quickPicks.forEach(qp => {
                quickPicksTags.push(qp.quickPicksTag)
            })

            let globalSets = []
            if (props.popupInfo.globals) {
                props.popupInfo.globals.forEach(g => {
                    globalSets.push(g.globalSet)
                })
            }
            setGlobals(globalSets)
    
            setSlide(copiedSlide)
            setSelectedChart(selectedChartId)
            setSelections(selections)
            setTrends(trends)
            setQuickPicksTags(quickPicksTags)
        }
    });

    if (userHasPermissionToView && userWasCreator) {
        return (
            <Dialog
                open={true}
                maxWidth={'md'}
                onClose={handleClick}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <CloseIcon onClick={handleClick} className="closePoup" />
                <DialogTitle id="alert-dialog-title" className="changepassdialog">
                    Edit Chart Queries
                </DialogTitle>
                <DialogContent>
                    <DialogContent id="alert-dialog-description">
                        <Grid container spacing={3}>
                            <Grid item xs={6}>
                                <div className="myInputOut">
                                    <Select
                                        className="myInput"
                                        value={selectedChart}
                                        onChange={handleChartSelectionChange}
                                        displayEmpty
                                        inputProps={{ 'aria-label': 'Without label' }}
                                    >
                                        {renderChartDropdownOptions()}
                                    </Select>
                                </div>
                            </Grid>
                            <Grid item xs={6}>
                                {renderChartPreviewImage()}
                            </Grid>
                        </Grid>
                        {validationErrorMessages.map((msg, index) => {
                            return <div key={`error-message-${index}`} style={{ "fontWeight": "bold", "color": "red" }}>{msg}</div>
                        })}
                        <Grid container>
                            {renderSelectionsGridComponent()}
                            {renderTrendsGridComponent()}
                        </Grid>
                        <div style={{ marginTop: 10 }}>
                            <button className="btn" type="submit" onClick={handleRefreshSlide} disabled={!formIsValid} value="Submit" id="submit_btn">
                                Update
                            </button>
                        </div>
                    </DialogContent>
                </DialogContent>
            </Dialog>
        )
    } else {
        return renderNotAllowed()
    }

    //#region Button Click Handlers
    function handleClick(event) {
        event.preventDefault()
        props.closePopup()
    }
    function handleChartSelectionChange(event) {
        event.preventDefault()
        setSelectedChart(event.target.value)
    }
    function handleRefreshSlide(event) {
        event.preventDefault()

        let documentTypeId = -1
        if (typeof (props.presentationView.slides) !== "undefined") {
            documentTypeId = 0
        } else if (typeof (props.presentationView.sheets) !== "undefined") {
            documentTypeId = 1
        }

        let foundSelectedChart = getSelectedChart()
        if (foundSelectedChart !== undefined && foundSelectedChart !== null) {
            props.closePopup()

            props.refreshPresentationSlide(
                props.presentationView.id,
                documentTypeId,
                props.currentDatabase.id,
                slide.id,
                selections,
                trends,
                props.presentationView.presentation.isTemplate,
                foundSelectedChart.id
            )

            if (props.presentationView.presentation.isTemplate === true) {
                navigate('/presentations')
            }
        }
    }
    function handleHideProps(area) {
        let hideProps = hideComps
        hideProps[area] = (hideProps[area]) ? false : true
        setHideComps(hideProps)
    }
    //#endregion

    //#region Render Methods
    function renderChartDropdownOptions() {
        if (slide.xP3Charts === undefined)
            return;

        let arr = []

        slide.xP3Charts.forEach((currentChart) => {
            arr.push(<MenuItem key={`chart-${currentChart.xP3SlideID}-${currentChart.id}`} value={currentChart.id}>
                {currentChart.name}
            </MenuItem>)
        });

        return [...arr]
    }
    function renderChartPreviewImage() {
        let foundSelectedChart = getSelectedChart()

        if (foundSelectedChart !== undefined && foundSelectedChart !== null) {
            return <img style={{
                border: '1px solid #eaeaea',
                width: "100%",
                height: "auto"
            }} src={`data:image/png;base64,${foundSelectedChart.imageBytes}`} alt={`chart_${foundSelectedChart.id}`} />;
        }
    }
    function renderItemSelector(dataArea) {
        let foundSelectedChart = getSelectedChart()
        let allConnectionIds = []

        props.presentationView.connectionInfos.forEach(c => {
            allConnectionIds.push(c.id)
        });

        if (foundSelectedChart !== undefined && foundSelectedChart !== null) {
            let dimensionForArea = ""
            let quickPicksTag = null

            if (dataArea === "Data Series") {
                dimensionForArea = foundSelectedChart.chartOptions.query.info.dataSeriesDimension
            } else {
                dimensionForArea = foundSelectedChart.chartOptions.query.info.dataCategoryDimension
            }

            quickPicksTag = quickPicksTags.find(qp => qp.dimensionAlias === dimensionForArea)
            if (quickPicksTag === undefined) {
                quickPicksTag = null
            }
            
            return <Accordion style={{ "marginTop": 10, "width": "100%" }} className="dimension-selector">
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                >
                    <Typography style={{ fontSize: 15, fontWeight: 400 }}>{dataArea}: {dimensionForArea}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <ItemSelector
                        chartId={foundSelectedChart.id}
                        dimensionName={dimensionForArea}
                        area={dataArea}
                        connectionId={props.presentationView.connectionInfos[0].id}
                        allConnectionIds={allConnectionIds}
                        originalSelections={foundSelectedChart.chartOptions.query.selections}
                        dataSource={foundSelectedChart.chartOptions.query.info.dataSource}
                        connectionName={foundSelectedChart.chartOptions.query.info.connection.name}
                        addedMultiSegments={addedMultiSegments}
                        quickPicksTag={quickPicksTag}
                        globals={globals}
                        onSelectionChange={(dimensionObject) => {
                            setNewQueryObject(foundSelectedChart, dimensionObject)
                        }} />
                </AccordionDetails>
            </Accordion>
        }
    }
    function renderItemSelectorDimension(dimensionForArea) {
        let foundSelectedChart = getSelectedChart()
        let allConnectionIds = []

        props.presentationView.connectionInfos.forEach(c => {
            allConnectionIds.push(c.id)
        });

        if (foundSelectedChart !== undefined && foundSelectedChart !== null) {
            let quickPicksTag = null

            quickPicksTag = quickPicksTags.find(qp => qp.dimensionAlias === dimensionForArea)
            if (quickPicksTag === undefined) {
                quickPicksTag = null
            }

            return <Accordion style={{ "marginTop": 10, "width": "100%" }} className="dimension-selector">
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                >
                    <Typography style={{ fontSize: 15, fontWeight: 400 }}>{dimensionForArea}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <ItemSelector
                        chartId={foundSelectedChart.id}
                        dimensionName={dimensionForArea}
                        area={""}
                        connectionId={props.presentationView.connectionInfos[0].id}
                        allConnectionIds={allConnectionIds}
                        originalSelections={foundSelectedChart.chartOptions.query.selections}
                        dataSource={foundSelectedChart.chartOptions.query.info.dataSource}
                        connectionName={foundSelectedChart.chartOptions.query.info.connection.name}
                        addedMultiSegments={addedMultiSegments}
                        quickPicksTag={quickPicksTag}
                        globals={globals}
                        onSelectionChange={(dimensionObject) => {
                            setNewQueryObject(foundSelectedChart, dimensionObject)
                        }} />
                </AccordionDetails>
            </Accordion>
        }
    }
    function renderSelectionsGridComponent() {
        let foundSelectedChart = getSelectedChart()

        if (foundSelectedChart !== undefined && foundSelectedChart !== null) {
            if (IsThisConnectionPowerBi(foundSelectedChart.chartOptions.query.info.connection.name)) {
                let qpDimensions = [];
                quickPicksTags.forEach((qp, qpIndex) => {
                    let dimensionLookup = foundSelectedChart.chartOptions.query.selections.find(s => s.dimensionAlias === qp.dimensionAlias)
                    if (dimensionLookup != null) {
                        qpDimensions.push(<div key={`qp-dimension-${qpIndex}`}>{renderItemSelectorDimension(qp.dimensionAlias)}</div>)
                    }
                });
                return (<Grid item xs={12}>
                    <Accordion>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                        >
                            <Typography style={{ fontSize: 15, fontWeight: 400 }}>Selections</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <div>
                                {qpDimensions}
                            </div>
                        </AccordionDetails>
                    </Accordion>
                </Grid>);
            } else {
                return (<Grid item xs={12}>
                    <Accordion>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                        >
                            <Typography style={{ fontSize: 15, fontWeight: 400 }}>Selections</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <div>
                                <div>
                                    {renderItemSelector("Data Series")}
                                </div>
                                <div>
                                    {renderItemSelector("Category")}
                                </div>
                            </div>
                        </AccordionDetails>
                    </Accordion>
                </Grid>)
            }
        }
    }
    function renderTrendsGridComponent() {
        if (shouldTrendsSectionRender()) {
            return (<Grid item xs={12}>
                <Accordion style={{ marginTop: 10 }}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                    >
                        <Typography style={{ fontSize: 15, fontWeight: 400 }}>Trends</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <div>
                            {renderTrendsSection()}
                        </div>
                    </AccordionDetails>
                </Accordion>
            </Grid>)
        }
    }
    function renderTrendsSection() {
        let foundSelectedChart = getSelectedChart()
        let allConnectionIds = []

        props.presentationView.connectionInfos.forEach(c => {
            allConnectionIds.push(c.id)
        });

        if (foundSelectedChart !== undefined && foundSelectedChart !== null) {
            let selectedInfo = foundSelectedChart.chartOptions.query.info;
            let selectedTrends = foundSelectedChart.chartOptions.query.trends;
            return <TrendEditor
                chartId={foundSelectedChart.id}
                dataSeriesDimension={foundSelectedChart.chartOptions.query.info.dataSeriesDimension}
                dataCategoryDimension={foundSelectedChart.chartOptions.query.info.dataCategoryDimension}
                info={selectedInfo}
                trends={selectedTrends}
                connectionId={props.presentationView.connectionInfos[0].id}
                allConnectionIds={allConnectionIds}
                dataSource={foundSelectedChart.chartOptions.query.info.dataSource}
                connectionName={foundSelectedChart.chartOptions.query.info.connection.name}
                globals={globals}
                onSelectionChange={(trends) => {
                    setNewTrendObjects(foundSelectedChart, trends)
                }}
            />;
        }
    }
    function renderAppropriateArrow(down) {
        if (down) {
            return downArrow("black", 22, null, "")
        } else {
            return upArrow("black", 22, null, "")
        }
    }
    function renderNotAllowed() {
        return (<Dialog
            open={true}
            maxWidth={'md'}
            onClose={handleClick}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <CloseIcon onClick={handleClick} className="closePoup" />
            <DialogTitle id="alert-dialog-title" className="changepassdialog">
                You Do Not Have Permission To View This Popup
            </DialogTitle>
        </Dialog>)
    }
    //#endregion

    //#region Data Handlers and Events
    function getSelectedChart() {
        let currentSlide = slide
        let selectedChartId = parseInt(selectedChart)
        
        if (selectedChartId > -1) {
            return currentSlide.xP3Charts.find(z => z.id === selectedChartId)
        } else {
            return null
        }
    }
    function getFirstTimeLoadSelections(charts) {
        let objectSelections = []

        charts.forEach(c => {
            objectSelections.push({
                xP3ChartId: c.id,
                selections: c.chartOptions.query.selections
            })
        })

        return objectSelections
    }
    function getFirstTimeTrends(charts) {
        let objectTrends = []

        charts.forEach(c => {
            objectTrends.push({
                xP3ChartId: c.id,
                trends: c.chartOptions.query.trends
            })
        })
        
        return objectTrends;
    }
    function setNewQueryObject(selectedChart, dimensionObject)  {
        let objectSelections = selections
        let formIsValid = true
        let errorMessages = []

        if (dimensionObject.items.length === 0) {
            formIsValid = false
            errorMessages.push(`Dimension ${dimensionObject["dimensionAlias"]} needs at least 1 selection item`)
        }

        for (let i = 0; i < objectSelections.length; i++) {
            if (objectSelections[i].xP3ChartId === selectedChart.id) {
                let currentObjectSelection = objectSelections[i]
                for (let j = 0; j < currentObjectSelection.selections.length; j++) {
                    if (currentObjectSelection.selections[j]["dimensionAlias"] === dimensionObject["dimensionAlias"]) {
                        objectSelections[i].selections[j] = dimensionObject
                    }
                }
            }
        }

        setSelections(objectSelections)
        setFormIsValid(formIsValid)
        setValidationErrorMessages(errorMessages)
    }
    function setNewTrendObjects(selectedChart, trendsFromComponent) {
        let objectTrends = trends
        let objectNeedsToBeAdded = true
        let formIsValid = true
        let errorMessages = []

        // I Need To Validate The Trends
        trendsFromComponent.forEach(t => {
            let check = isThisTrendValid(t)

            if (check["valid"] === false) {
                formIsValid = false
                errorMessages.push(check["errorMessage"])
            }
        })

        for (let i = 0; i < objectTrends.length; i++) {
            if (objectTrends[i].xP3ChartId === selectedChart.id) {
                objectNeedsToBeAdded = false
                objectTrends[i].trends = trendsFromComponent
            }
        }

        if (objectNeedsToBeAdded) {
            objectTrends.push({
                xP3ChartId: selectedChart.id,
                trends: trendsFromComponent
            })
        }

        setTrends(objectTrends)
        setFormIsValid(formIsValid)
        setValidationErrorMessages(errorMessages)
    }
    function setIfUserHasAppropriatePermissions(currentUser) {
        if (currentUser !== null) {
            setUserHasPermissionToView(doesThisUserHaveThisAuthorization(currentUser, "ChartQuery"))
        } else {
            setUserHasPermissionToView(false)
        }
    }
    function setIfUserIsCreator(currentUser, presentation) {
        let rtnVal = IsThisUserThePresentationsCreator(currentUser, presentation)
        setUserWasCreator(rtnVal)
        return rtnVal
    }
    function isThisTrendValid(trend) {
        let rtnVal = { "valid": true, "errorMessage": "" }

        switch (trend.type) {
            case 0:
                trend.slicers.forEach(slicer => {
                    if (slicer.items.length < 1) {
                        rtnVal = { "valid": false, "errorMessage": `Slicer dimension ${slicer["dimensionAlias"]} requires at least 1 selection` }
                    }
                })
                break
            case 1:
            case 2:
                trend.slicers.forEach(slicer => {
                    if (slicer.items.length < 1) {
                        rtnVal = { "valid": false, "errorMessage": `Slicer dimension ${slicer["dimensionAlias"]} requires at least 1 selection` }
                    }
                })

                trend.selectors.forEach(selector => {
                    if (selector.items.length !== 2) {
                        rtnVal = { "valid": false, "errorMessage": `Selector dimension ${selector["dimensionAlias"]} requires 2 selections` }
                    }

                    selector.items.forEach(item => {
                        if (item === undefined) {
                            rtnVal = { "valid": false, "errorMessage": "Selector requires 2 selections" }
                        } else if (item.caption === "") {
                            rtnVal = { "valid": false, "errorMessage": "Selector requires 2 selections" }
                        }
                    });
                });

                if (trend.selectors.length !== 1) {
                    rtnVal = { "valid": false, "errorMessage": "Trend must only have one selector" }
                }

                break
            case 4:
                if (trend.baseValue === null) {
                    rtnVal = { "valid": false, "errorMessage": "Please select a base item" }
                }

                trend.slicers.forEach(slicer => {
                    if (slicer.items.length < 1) {
                        rtnVal = { "valid": false, "errorMessage": `Slicer dimension ${slicer["dimensionAlias"]} requires at least 1 selection` }
                    }
                })

                if (trend.slicers.length !== 2) {
                    rtnVal = { "valid": false, "errorMessage": "Nominal Value trends must have two slicers" }
                }

                break
            default:
                rtnVal = { "valid": false, "errorMessage": "Unsupported trend type" }
                break
        }

        return rtnVal
    }
    function shouldTrendsSectionRender() {
        let foundSelectedChart = getSelectedChart()

        if (foundSelectedChart !== undefined && foundSelectedChart !== null) {
            let selectedTrends = foundSelectedChart.chartOptions.query.trends
            if (selectedTrends.length > 0) {
                return true
            }
        }

        return false
    };
    //#endregion
}

function mapStateToProps(state) {
    return {
        popupInfo: state.ui.popupInfo,
        currentDatabase: state.databases.currentDatabase,
        qpDataSource: state.databases.qpDataSource,
        presentationSource: state.databases.presentationSource,
        presentationView: state.presentations.present.presentationView,
        currentUser: state.users.currentUser,
        userID: state.users.userID
    }
}

function mapDispatchToProps(dispatch) {
    return {
        ...bindActionCreators({
            closePopup,
            showPopup,
            changeQPs,
            refreshPresentationSlide,
            getCurrentUser
        }, dispatch)
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ChartQueryPopup))